module.exports = __webpack_public_path__ + "files/21e01fa676b2e1b84e16be6af2528d6b.png";